import styled, { css } from 'styled-components';

import { Icon } from '@atoms';

export const BackButton = styled(Icon)`
  ${() => css`
    transform: rotate(90deg);
  `}
`;
